import React, { createContext, useMemo, useState } from 'react'
import { BrowserRouter as Router, Route, useHistory } from 'react-router-dom'
import Login from './components/login/Login'
import { Redirect } from 'react-router'
import EditEngagement from './components/engagement/EditEngagement'
import EditTenantPage from './components/tenant/admin/tab/page/EditTenantPage'
import PublicDepartureDecision from './components/departure/public/PublicDepartureDecision'
import Layout from './layouts/Layout'
import PasswordReset from './components/login/PasswordReset'

export const UserContext = createContext({
  token: null,
  exp: null,
  username: null,
  id: null,
  authorities: [],
})

export const apiUrl = process.env.REACT_APP_API_URL
export const timeout = 10000


export const emptyUser = JSON.parse(
  JSON.stringify({
    token: null,
    exp: null,
    username: null,
    id: null,
    authorities: [],
  }),
)

export default function App() {
  const hist = useHistory()

  let userState = getWithExpiry('token')

  if (!userState) {
    userState = emptyUser
  }
  const [user, setUser] = useState(userState)

  const value = useMemo(() => ({ user, setUser }), [user, setUser])

  return (
    <UserContext.Provider value={value}>
      <Router history={hist}>
        <Route exact path="/">
          {user.authorities.length !== 0 ? <Redirect to="/dashboard"/> : <Login/>}
        </Route>
        <Route exact path="/admin/tenants/:tenantId" component={EditTenantPage}/>
        <Route exact path="/departments/info/engagements/:engagementId" component={EditEngagement}/>
        <Route exact path="/public/departures/:departureId" component={PublicDepartureDecision}/>
        <Route exact path="/login" component={Login}/>
        <Route exact path="/password-reset" component={PasswordReset}/>
        <Route
          path="/dashboard"
          render={() => {
            if (user.token !== null) return <Layout user={user}/>
            return <Login/>
          }}
        />
      </Router>
    </UserContext.Provider>
  )
}

// const smartdormHeaderName = 'X-Smartdorm-Dorm-ID'
// const smartdormID = '4885b6d1-bbe4-4d40-bd24-bce33f0d7728'
//
// export function authToken() {
//   let userState = getWithExpiry('token')
//   if (userState != null)
//     return userState['token']
//   else return ''
// }

// export function authHeader() {
//   let userState = getWithExpiry('token')
//   if (userState && userState.token) {
//     return { Authorization: 'Bearer ' + userState.token, dormIdHeader: dormId }
//   } else {
//     return { dormIdHeader: dormId }
//   }
// }

export function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key)

  if (itemStr == null) {
    return null
  }

  const item = parseJwt(itemStr)
  const now = new Date()

  if (now.getTime() / 1000 > item.exp) {
    localStorage.removeItem(key)
    return null
  }
  return item
}

export function parseJwt(token) {
  let base64Url = token.split('.')[1]
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(''),
  )

  let jsonData = JSON.parse(jsonPayload)
  jsonData['token'] = token

  return jsonData
}
